import { useState, useEffect } from "react";

export default function AgeGate() {
  const [verified, setVerified] = useState(() => localStorage.getItem("dg_age_ok") === "true");

  useEffect(() => {
    document.body.style.overflow = verified ? "" : "hidden";
  }, [verified]);

  if (verified) return null;

  const accept = () => {
    localStorage.setItem("dg_age_ok", "true");
    setVerified(true);
  };

  return (
    <div
      data-testid="age-gate"
      className="fixed inset-0 z-[100] flex items-center justify-center bg-black/90 backdrop-blur-2xl px-6"
    >
      <div className="max-w-lg w-full text-center border border-white/10 bg-[#050505] p-10 md:p-14">
        <p className="label-caps text-emerald-500 mb-6">Dark Growers Genetics — Est. 2018</p>
        <h2 className="font-display text-5xl md:text-6xl leading-none text-slate-100 mb-6">
          Are you 21 <span className="italic text-emerald-500">or older?</span>
        </h2>
        <p className="text-slate-400 text-sm leading-relaxed mb-10 max-w-md mx-auto">
          You must be of legal age to enter. All products are lab-tested clean genetics containing
          less than 0.3% Delta-9 THC, sold in compliance with state and federal law.
        </p>
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <button
            data-testid="age-gate-confirm"
            onClick={accept}
            className="bg-emerald-600 text-white hover:bg-emerald-500 transition-colors font-medium px-10 py-3.5 text-sm tracking-wide"
          >
            Yes, I am 21+
          </button>
          <a
            data-testid="age-gate-exit"
            href="https://www.google.com"
            className="border border-white/20 text-slate-300 hover:border-white/50 hover:text-white transition-colors px-10 py-3.5 text-sm tracking-wide"
          >
            Exit
          </a>
        </div>
      </div>
    </div>
  );
}
